import React, { useContext, useMemo, useState } from 'react';
import { PendingApprovalStepProps } from 'components/SignUpForm/Steps/PendingApprovalStep';
import { ReactComponent as PendingApproval1 } from 'assets/images/PendingApproval/PendingApproval1.svg';
import { ReactComponent as PendingApproval2 } from 'assets/images/PendingApproval/PendingApproval2.svg';
import { ReactComponent as PendingApproval3 } from 'assets/images/PendingApproval/PendingApproval3.svg';
import { ReactComponent as PendingApproval4 } from 'assets/images/PendingApproval/PendingApproval4.svg';
import { ReactComponent as ChatBullet } from 'assets/icons/ChatCircle.svg';
import { ReactComponent as BookBullet } from 'assets/icons/BookCircle.svg';
import { useLoggedInUser } from 'features/auth/hooks/useAuthData';

export const usePendingApproval = () => {
  const [currentScreenIndex, setCurrentScreenIndex] = useState(0);
  const user = useLoggedInUser();

  const navigateForward = () => {
    setCurrentScreenIndex((prev) => prev + 1);
  };

  const navigateBack = () => {
    setCurrentScreenIndex((prev) => prev - 1);
  };

  const contactLink = useMemo(() => {
    const type = user?.hospital.contact_link_type;
    const value = user?.hospital.contact_link; // Wellframe default contact support number.

    return {
      type,
      value,
    };
  }, [user?.hospital?.contact_link, user?.hospital?.contact_link_type]);

  const isBackButtonDisabled = currentScreenIndex === 0;

  const screenData: PendingApprovalStepProps[] = [
    {
      image: <PendingApproval1 />,
      title: 'carousel_slide_1_header',
      description: 'carousel_slide_1_body',
      buttonTitle: 'caregiver_what_now_button',
    },
    {
      image: <PendingApproval2 />,
      title: 'your_account_has_been_sent',
      description: 'carousel_slide_2_body',
      buttonTitle: 'caregiver_how_notify_button',
    },
    {
      image: <PendingApproval3 />,
      title: 'check_your_email_title',
      description: 'check_your_email_subhead',
      buttonTitle: 'caregiver_what_gain_access_button',
    },
    {
      image: <PendingApproval4 />,
      title: 'caregiver_be_in_touch',
      description: 'caregiver_once_you_gain_access',
      contactLink,
      bulletPoints: [
        {
          icon: ChatBullet,
          text: `well_be_in_touch_bullet_one`,
        },
        {
          icon: BookBullet,
          text: `well_be_in_touch_bullet_two`,
        },
      ],
    },
  ];

  return {
    screenData: screenData[currentScreenIndex],
    navigateBack,
    isBackButtonDisabled,
    navigateForward,
  };
};
